'use client';

import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@/contexts/ApiContext';

export const GAME_STATS_QUERY_KEY = ['gameStats'] as const;

export function useGameStatsQuery() {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: GAME_STATS_QUERY_KEY,
    queryFn: () => apiClient.api.publicControllerGetGameStats(),
    staleTime: 30 * 1000,
  });
}
